/* eslint-disable @typescript-eslint/camelcase */
import { FormSecurityValues } from 'modules/environments/interfaces';

export const initial: FormSecurityValues = {
  activate: false,
  min_length: 8,
  require_upper: false,
  require_lower: false,
  require_num: false,
  require_symbol: false,
  expire_passwords: false,
  expire_days: 10,
  max_auth_tries: 5,
  zero_trust: {
    enabled: false,
    allow_list: [],
    port: null,
    whitelist_cleanup_interval_days: 30,
  },
  check_history: false,
  check_complexity: false,
};
